import React, { useEffect, useState, useRef } from "react";
import AssetList from "./asset-list";
import AssetGroupList from "./asset-group-list";

function MachineList() {
  return (
    <div>
      <h1 className="page-header">
        Analytics <small>stats, overview & performance</small>
      </h1>
      <ul className="nav nav-tabs">
        <li className="nav-item me-1">
          <a href="#asset" className="nav-link active" data-bs-toggle="tab">
            <i className="fa fa-boxes"></i> Asset List
          </a>
        </li>
        <li className="nav-item me-1">
          <a href="#group" className="nav-link" data-bs-toggle="tab">
            <i className="fa fa-boxes-packing"></i> Asset Group List
          </a>
        </li>
      </ul>
      <div className="tab-content pt-3">
        <div className="tab-pane fade show active" id="asset">
          <AssetList />
        </div>
        <div className="tab-pane fade" id="group">
          <AssetGroupList />
        </div>
      </div>
    </div>
  );
}

export default MachineList;
